/**
 * Lógica pura de la cabecera del día (GEN-PX-008): fecha en español, saludo por
 * tramo horario, nombre de pila y cifras. Sin React ni reloj propio: todo recibe
 * la hora (`Date`) o los datos, para que se pueda probar a cualquier hora.
 */

const DIAS = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado']
const MESES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto',
  'septiembre', 'octubre', 'noviembre', 'diciembre']
const DIA_MS = 86_400_000

const dos = n => String(n).padStart(2, '0')
const capitalizar = s => s.charAt(0).toUpperCase() + s.slice(1)

/** «Martes 22 de octubre · 08:41», hora local del navegador. La versalita la pone el CSS. */
export function fechaHora(ahora) {
  return `${capitalizar(DIAS[ahora.getDay()])} ${ahora.getDate()} de ${MESES[ahora.getMonth()]}`
    + ` · ${dos(ahora.getHours())}:${dos(ahora.getMinutes())}`
}

/** Tramos: 06:00–13:59 días · 14:00–20:59 tardes · 21:00–05:59 noches. */
export function saludoDe(ahora) {
  const h = ahora.getHours()
  if (h >= 6 && h < 14) return 'Buenos días'
  if (h >= 14 && h < 21) return 'Buenas tardes'
  return 'Buenas noches'
}

export const primerNombre = (nombre) => (nombre ?? '').trim().split(/\s+/)[0] || ''

/** Agentes activos = los operativos (los mismos que pinta «Tu equipo de IA»). */
export const agentesActivos = (disponibles) => (Array.isArray(disponibles) ? disponibles.length : 0)

/**
 * Conversaciones del usuario con actividad en los últimos 7 días. `updated_at`
 * (ISO, descriptor.chats) es la última actividad; un chat sin fecha válida no
 * cuenta (no se inventa). Una fecha futura por desfase de reloj sí cuenta.
 */
export function conversaciones7d(chats, ahora) {
  if (!Array.isArray(chats)) return 0
  const desde = ahora.getTime() - 7 * DIA_MS
  return chats.filter(c => {
    const t = new Date(c?.updated_at).getTime()
    return Number.isFinite(t) && t >= desde
  }).length
}

/** Cifras de la cabecera, en orden. Añadir una = añadir un elemento aquí. */
export function cifrasDe({ disponibles, chats }, ahora) {
  return [
    { id: 'agentes', valor: agentesActivos(disponibles), etiqueta: 'agentes activos' },
    { id: 'conversaciones', valor: conversaciones7d(chats, ahora), etiqueta: 'conversaciones en 7 días' },
  ]
}

/** Milisegundos hasta el próximo minuto en punto (para refrescar la hora sin deriva). */
export const msHastaMinuto = (ahora) => 60_000 - (ahora.getSeconds() * 1000 + ahora.getMilliseconds())
